export default "__VITE_ASSET__C7f$tFD$__"